export default {
  selected_offer: "Valor da Parcela",
  selected_lower_my_payment_offer: "Novo valor de Parcela"
}